// Returns true when the company's effective plan has the feature flag on.
// Designed to drive `<PlanGate feature="..." />` and direct conditional UI.

import { useCurrentPlan } from './useCurrentPlan';
import type { FeatureKey } from '../types';

export function useFeatureAccess(feature: FeatureKey): {
  enabled: boolean;
  isLoading: boolean;
} {
  const { data, isLoading } = useCurrentPlan();
  const flags = data?.usage;
  let enabled = false;
  if (flags) {
    switch (feature) {
      case 'notifications':
        enabled = !!flags.featNotifications;
        break;
      case 'activeLog':
        enabled = !!flags.featActiveLog;
        break;
      case 'userManagement':
        enabled = !!flags.featUserManagement;
        break;
      case 'stockImport':
        enabled = !!flags.featStockImport;
        break;
      case 'aiAssistant':
        enabled = !!flags.featAiAssistant;
        break;
      case 'surveyBuilder':
        enabled = !!flags.featSurveyBuilder;
        break;
      case 'brandInventory':
        enabled = !!flags.featBrandInventory;
        break;
      case 'ethnicityCollection':
        enabled = !!flags.featEthnicityCollection;
        break;
      case 'nationalityCollection':
        enabled = !!flags.featNationalityCollection;
        break;
      case 'customQuestions':
        enabled = !!flags.featCustomQuestions;
        break;
      case 'pdfExport':
        enabled = !!flags.featPdfExport;
        break;
      case 'reporterRole':
        enabled = !!flags.featReporterRole;
        break;
    }
  }
  return { enabled, isLoading };
}
